import Input from "../../../common/Input";

const ClinicAddress = ({
  formik,
  isEdit,
  handleEditIconClick,
  handleBlur,
  editingField,
  isDisabled,
}) => {
  const { values, handleChange, touched, errors, setFieldTouched } = formik;
  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">
        Clinic Address
      </h2>
      <div className="grid grid-cols-12 gap-[8px]">
        <div className="col-span-12 md:col-span-6 xl:col-span-4">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Premises No./ Floor*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.premisesNo"
            id="clinicAddress.premisesNo"
            value={values?.clinicAddress?.premisesNo}
            onChange={handleChange}
            isError={
              touched?.clinicAddress?.premisesNo &&
              Boolean(errors?.clinicAddress?.premisesNo)
            }
            errorMessage={errors?.clinicAddress?.premisesNo}
            disabled={isDisabled && editingField !== "clinicAddress.premisesNo"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.premisesNo") : ""
            }
            onEditClick={() => handleEditIconClick("clinicAddress.premisesNo")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 md:col-span-6 xl:col-span-4">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Premises Name*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.premisesName"
            id="clinicAddress.premisesName"
            value={values?.clinicAddress?.premisesName}
            onChange={handleChange}
            isError={
              touched?.clinicAddress?.premisesName &&
              Boolean(errors?.clinicAddress?.premisesName)
            }
            errorMessage={errors?.clinicAddress?.premisesName}
            disabled={
              isDisabled && editingField !== "clinicAddress.premisesName"
            }
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.premisesName") : ""
            }
            onEditClick={() =>
              handleEditIconClick("clinicAddress.premisesName")
            }
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 md:col-span-6 xl:col-span-4">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Landmark"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.landmark"
            id="clinicAddress.landmark"
            value={values?.clinicAddress?.landmark}
            onChange={handleChange}
            disabled={isDisabled && editingField !== "clinicAddress.landmark"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.landmark") : ""
            }
            onEditClick={() => handleEditIconClick("clinicAddress.landmark")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 md:col-span-6 xl:col-span-4">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Area/Road*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.areaRoad"
            id="clinicAddress.areaRoad"
            value={values?.clinicAddress?.areaRoad}
            onChange={handleChange}
            isError={
              touched?.clinicAddress?.areaRoad &&
              Boolean(errors?.clinicAddress?.areaRoad)
            }
            errorMessage={errors?.clinicAddress?.areaRoad}
            disabled={isDisabled && editingField !== "clinicAddress.areaRoad"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.areaRoad") : ""
            }
            onEditClick={() => handleEditIconClick("clinicAddress.areaRoad")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 md:col-span-6 xl:col-span-4">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="City*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.city"
            id="clinicAddress.city"
            value={values?.clinicAddress?.city}
            onChange={handleChange}
            isError={
              touched?.clinicAddress?.city &&
              Boolean(errors?.clinicAddress?.city)
            }
            errorMessage={errors?.clinicAddress?.city}
            disabled={isDisabled && editingField !== "clinicAddress.city"}
            showEditIcon={isEdit}
            onBlur={() => (handleBlur ? handleBlur("clinicAddress.city") : "")}
            onEditClick={() => handleEditIconClick("clinicAddress.city")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 md:col-span-6 xl:col-span-4">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Pin Code*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.pinCode"
            id="clinicAddress.pinCode"
            value={values.clinicAddress?.pinCode}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("clinicAddress.pinCode", true, false);
            }}
            isError={
              touched?.clinicAddress?.pinCode &&
              Boolean(errors?.clinicAddress?.pinCode)
            }
            errorMessage={errors?.clinicAddress?.pinCode}
            disabled={isDisabled && editingField !== "clinicAddress.pinCode"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.pinCode") : ""
            }
            onEditClick={() => handleEditIconClick("clinicAddress.pinCode")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 lg:col-span-6">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="State*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.state"
            id="clinicAddress.state"
            value={values.clinicAddress.state}
            onChange={handleChange}
            isError={
              touched?.clinicAddress?.state &&
              Boolean(errors?.clinicAddress?.state)
            }
            errorMessage={errors?.clinicAddress?.state}
            disabled={isDisabled && editingField !== "clinicAddress.state"}
            showEditIcon={isEdit}
            onBlur={() => (handleBlur ? handleBlur("clinicAddress.state") : "")}
            onEditClick={() => handleEditIconClick("clinicAddress.state")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12 lg:col-span-6">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Clinic Contact Number"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.clinicContactNumber"
            id="clinicAddress.clinicContactNumber"
            value={values?.clinicAddress?.clinicContactNumber}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("clinicAddress.clinicContactNumber", true, false); // Mark the field as touched
            }}
            isError={
              touched?.clinicAddress?.clinicContactNumber &&
              Boolean(errors?.clinicAddress?.clinicContactNumber)
            }
            errorMessage={errors?.clinicAddress?.clinicContactNumber}
            disabled={
              isDisabled && editingField !== "clinicAddress.clinicContactNumber"
            }
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.clinicContactNumber") : ""
            }
            onEditClick={() =>
              handleEditIconClick("clinicAddress.clinicContactNumber")
            }
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
        <div className="col-span-12">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            labelName="Google Map URL*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="clinicAddress.googleMapUrl"
            id="clinicAddress.googleMapUrl"
            value={values?.clinicAddress?.googleMapUrl}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("clinicAddress.googleMapUrl", true, false); // Mark the field as touched
            }}
            isError={
              touched?.clinicAddress?.googleMapUrl &&
              Boolean(errors?.clinicAddress?.googleMapUrl)
            }
            errorMessage={errors?.clinicAddress?.googleMapUrl}
            disabled={
              isDisabled && editingField !== "clinicAddress.googleMapUrl"
            }
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("clinicAddress.googleMapUrl") : ""
            }
            onEditClick={() =>
              handleEditIconClick("clinicAddress.googleMapUrl")
            }
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
      </div>
    </div>
  );
};

export default ClinicAddress;
